import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Icon } from '@artprov/design-system';

/**
 * Celda de acciones para Matching Judicial.
 * Muestra un icono de acciones por fila.
 */
export const AccionesCell = memo(function AccionesCell({ idEmail, idJuicio }) {
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        const params = new URLSearchParams({ idEmail });
        if (idJuicio != null) {
            params.append('idJuicio', idJuicio);
        }
        navigate(`/matching-judicial/detalle?${params.toString()}`);
    }, [idEmail, idJuicio, navigate]);

    return (
        <div className="flex justify-center items-center">
            {idEmail && (
                <Button
                    iconOnly
                    aria-label="Ver más"
                    variant="ghost"
                    size="xs"
                    onClick={handleClick}
                    startIcon={<Icon icon="visibility" size="small" />}
                />)
            }
        </div>
    );
});

AccionesCell.propTypes = {
    idEmail: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    idJuicio: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
